<template>
  <section class="descrGus">
    <div class="container">
      <p class="descrGeralGus inter-regular">{{ $t('homePage.descricaoGus4') }}</p>
      <p class="descrGeralGus inter-regular">{{ $t('homePage.descricaoGus5') }}</p>
      <div class="carousel" aria-label="Carrossel de projetos">
        <div class="carousel-track">
          <img
            v-for="(image, index) in carouselLoopImages"
            :key="`${image.src}-${index}`"
            :src="image.src"
            :alt="image.alt"
            class="carousel-image"
            draggable="false"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import projetoContratempo from '@/assets/carrossel-projetos/contratempo.jpg'
import projetoBenAzelart from '@/assets/carrossel-projetos/ben-azelart-coaster.jpg'
import projetoEureka from '@/assets/carrossel-projetos/eureka.jpg'
import projetoOMLindoia from '@/assets/carrossel-projetos/bendito-lindoia.jpg'
import projetoOMCampos from '@/assets/carrossel-projetos/bendito-campos.jpg'

// Troque as imagens do carrossel aqui.
const projectCarouselImages = [
  { src: projetoContratempo, alt: 'Contratempo' },
  { src: projetoOMCampos, alt: 'Oompa Mobile Campos do Jordao' },
  { src: projetoEureka, alt: 'Eureka' },
  { src: projetoBenAzelart, alt: 'Ben Azelart Coaster' },
  { src: projetoOMLindoia, alt: 'Oompa Mobile Aguas de Lindoia' }
]

const carouselLoopImages = [...projectCarouselImages, ...projectCarouselImages]
</script>

<style scoped>
.descrGus {
  min-height: 0;
  background-image: url('@/assets/fundo-contratempo-mmbranco.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  overflow-x: hidden;
}

.descrGeralGus {
  color: var(--color-bg-dark);
  font-size: 20px;
  font-weight: 300;
  line-height: 1.5;
  margin: 0;
  text-align: justify;
}

.container {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 24px;
  text-align: left;
}

.carousel {
  width: 100%;
  overflow: hidden;
  margin-top: 28px;
}

.carousel-track {
  display: flex;
  width: max-content;
  gap: 16px;
  animation: scroll-right 45s linear infinite;
}

.carousel-image {
  width: 300px;
  height: 400px;
  object-fit: cover;
  border-radius: 0;
  flex-shrink: 0;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
}

@keyframes scroll-right {
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(0%);
  }
}

@media (aspect-ratio <= 3/4) {
  .descrGus {
    background-attachment: scroll;
  }

  .container {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  .descrGeralGus {
    font-size: 20px;
    line-height: 1.5;
  }

  .carousel-image {
    width: 150px;
    height: 205px;
  }
}

</style>
